import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { customerInfoColumns } from "./cols";
import { CustomerInfo } from "../../../models/Customer";
import EmptyState from "../../atoms/EmptyState";
import { styles } from "../insuranceInformation/DataGrid.styles";

interface CustomerInfoDataGridProps {
  data?: CustomerInfo[];
  loading?: boolean;
}

const CustomerInfoDataGrid = ({ data, loading }: CustomerInfoDataGridProps) => {
  return (
    <Stack>
      <DataGrid
        autoHeight
        hideFooter
        columnHeaderHeight={52}
        rowHeight={56}
        loading={loading}
        data-testid="customer-info-table"
        sx={!!data ? styles.table : emptyStyles.table}
        isRowSelectable={() => false}
        rows={data || []}
        columns={customerInfoColumns}
        getRowId={(row: CustomerInfo) =>
          row.omneId ?? Math.random().toString(36)
        }
        slots={{
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
      />
    </Stack>
  );
};

export const emptyStyles = {
  table: {
    fontFamily: "Novera,sans-serif",
    fontSize: 14,
    "& .MuiDataGrid-overlayWrapperInner": {
      minHeight: 200,
    },
    "& .MuiDataGrid-virtualScroller": {
      minHeight: 200,
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#EEEEEE",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      whiteSpace: "unset",
    },
    "& .MuiDataGrid-columnHeaderTitle , & .MuiDataGrid-columnHeaderTitleContainerContent>.MuiTypography-root":
      {
        fontWeight: 800,
        color: "mono.grey.3",
      },
  },
};

export default CustomerInfoDataGrid;
